/**
 * Colour helpers.
 *
 * The colour-name-to-hex map, the AI colour lookup and the swatch helpers were removed
 * 2026-10-25. The order line dialog no longer shows swatches, so nothing read them.
 */

/**
 * Check if a feature is likely a color feature based on its name.
 */
export function isColorFeature(featureName: string): boolean {
  if (!featureName) return false;
  return featureName.toLowerCase().includes('color');
}
